// extracted by mini-css-extract-plugin
export default {"topic_slide":"index_topic_slide_lJoSv","slide_box":"index_slide_box_Yby2k","dot":"index_dot_78LFP","current":"index_current_3jWKR index_dot_78LFP"};